import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import "./styles/index.css";

const container = document.getElementById("root")!;

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Built pages arrive already filled in (see scripts/prerender.mjs), so attach
// to that markup instead of rebuilding it. The dev server serves an empty
// root, so fall back to a normal render there.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
